import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AdminContextProvider } from './context/admin-context';
import { AdminApp } from './admin/admin-app';
import { QBO } from './qbo/qbo';
import { MediaContextProvider, createMediaStyle } from './context/responsive-context';

export const App = () => {
  const mediaStyle = createMediaStyle();

  const loadZendeskSnippet = () => {
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.async = true;
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=e3e307c0-d674-4a8d-8b92-1845c008ad45';
    document.head.appendChild(script);

    script.onload = () => {
      window.zE('webWidget', 'hide');
    };
  };

  useEffect(() => {
    loadZendeskSnippet();
  }, []);

  const getAdminApp = () => (
    <AdminContextProvider>
      <>
        <style>{mediaStyle}</style>
        <MediaContextProvider>
          <AdminApp />
        </MediaContextProvider>
      </>
    </AdminContextProvider>
  );

  const contextPath = window.location.pathname.substring(0, window.location.pathname.indexOf('/manager'));
  return (
    <BrowserRouter>
      <Routes>
        <Route path={'/qbo/*'} element={<QBO />} />
        <Route path={`${contextPath}/manager/*`} element={getAdminApp()} />
      </Routes>
    </BrowserRouter>
  );
};
